
export default class Filter {
  constructor ({ type, key, value }) {
    this.value = value
    this.keyField = key
    this.keyFieldType = type
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/Filter.js